import React,{useEffect} from "react";
import '../Css/Languageprogram.css';
// import { NavLink } from "react-router-dom";
import commingsoon from '../Components/image/underconstruction1.png';
import Aos from "aos";
import 'aos/dist/aos.css';
import Footer from '../Components/Footer';

function Languageprogram()
{
    useEffect((()=>
  {
    document.title ='Language-Programs';
  }))
  useEffect(()=>
  {
    Aos.init({duration:1000})
  },[])
    return(
      <div>
        <div id="languagemain" 
        data-aos="zoom-in-out">
         <img src={commingsoon}  alt="commingsoon"/>
       
        
        </div>
        <div className="container-fluid">
<div className="row">
   {<Footer/>}
</div>
</div>
</div>
    )
}
export default Languageprogram;